import { Logo } from '@/components/Logo/Logo';
import { Button, Text } from '@/design-system';

export const GraphDesktopDeprecationPage = () => {
  return (
    <div className="fixed z-0 flex h-screen w-screen items-center justify-center bg-secondary">
      <main className="mx-4 flex w-full max-w-[480px] flex-col gap-4 rounded-lg border border-secondary bg-popover p-6 text-primary">
        <div className="mb-2 text-3xl">
          <Logo />
        </div>
        <Text variant="h1" weight="normal">
          Trying to use LangGraph Studio on your desktop?
        </Text>
        <Text variant="md" weight="normal" className="py-4">
          The MacOS Desktop app was deprecated on March 11, 2025 and is no
          longer supported.
        </Text>
        <Text variant="md" weight="normal">
          Studio now runs in your browser! See{' '}
          <a
            href="https://docs.langchain.com/langgraph-platform/quick-start-studio/"
            className="underline"
          >
            here
          </a>{' '}
          for how to get started.
        </Text>

        <a href="https://docs.langchain.com/langgraph-platform/quick-start-studio/">
          <Button
            onClick={() => window.location.reload()}
            variant="outlined"
            color="secondary"
            className="w-full"
            size="md"
          >
            Run Studio in your browser
          </Button>
        </a>
      </main>
    </div>
  );
};
